import { InlineGreek } from '../components/InlineGreek';
import type { Frame, Item } from '../content/types';

interface Props {
  item: Item;
  frame: Frame | null;
  /** Open by default; folded once the learner knows the phrase (support becomes clutter). */
  open: boolean;
}

/** Word-by-word, the pattern and the "why" note: short, and after the learner has heard and said the phrase. */
export function WhyNote({ item, frame, open }: Props) {
  const body = (
    <div className="stack" style={{ gap: 14 }}>
      <div>
        <p className="note-title">Word by word</p>
        <p className="gloss">{item.gloss}</p>
      </div>
      {frame && (
        <div>
          <p className="note-title">Pattern</p>
          <p>
            <span className="greek greek-body" lang="el">
              {frame.pattern}
            </span>{' '}
            <span className="muted">= {frame.meaning}</span>
          </p>
          <p className="small muted" style={{ marginTop: 4 }}>
            The gap is the part you can swap.
          </p>
        </div>
      )}
      {item.why && (
        <div>
          <p className="note-title">Why it's built this way</p>
          <p>
            <InlineGreek text={item.why} />
          </p>
        </div>
      )}
    </div>
  );

  if (open) return <div className="note">{body}</div>;
  return (
    <details className="note">
      <summary style={{ cursor: 'pointer', fontWeight: 600, color: 'var(--aegean)' }}>Word by word and why</summary>
      <div style={{ marginTop: 12 }}>{body}</div>
    </details>
  );
}
